<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <!--EmFilterTree-->
            <em-filter-tree class="col-lg-3 float-lg-left"
                            filterEnable
                            :entity="modelName"
                            filterState="levelTreeFilter"
                            loadState="levelTreeNodes"
                            :selectedId="$_emLevelTreeListMixin_menuTreeSelectedId"
                            @onclick="$_emLevelTreeListMixin_menuTreeOnClick"></em-filter-tree>
            <div class="float-lg-right col-lg-9">
                <div id="accordionFilter" class="content">
                    <div class="card">
                        <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                             data-parent="#accordionFilter">
                            <div class="card-body">
                                <form>
                                    <em-filter :entity="modelName"  ref="emListFilter"
                                               @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"/>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="sithMesMstLocationResultTable" class="content">
                    <div class="card my-1">
                        <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                             data-parent="#accordionResult">
                            <div class="card-body">
                                <em-table :entity="modelName"
                                          ref="emTable"
                                          withCustomRowActions exportDisabled :inlineActionsDisabled="prop_inline!=='1'"
                                          @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                          @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                  <template #customRowActions="{row}">
                                    <b-button-group>
                                      <em-button type="gotoChild" customLabel="用户责任区" show-name
                                                 v-bind:class="'btn btn-outline-primary btn-sm'"
                                                 @click="gotoChild(row)">
                                      </em-button>
                                    </b-button-group>
                                  </template>
                                </em-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"/>
    </div>
</template>
<script>
    // Author YuJiaBei
    // Date 2020-10-02 10:11:07

    import emLevelTreeListMixin from "@/mixin/em/levelTree/list";
    import EmFilterTree from "@/components/em/EmFilterTree";
    import EmFilter from "@/components/em/EmFilter";
    import emCommonGotoMixin from "@/mixin/em/common/goto";

    export default {
        name: "sithMesMstLocationLevelTreeListView",
        mixins: [emLevelTreeListMixin,emCommonGotoMixin],
        components: {EmFilter, EmFilterTree},
        props:{
            //是否启用行编辑
            prop_inline: {
                type: String,
                default: "0"
            }
        },
      methods: {
        gotoChild(row) {
          this.$_emGotoMixin_gotoHolderList("sithMesMstUserLocation"
              , {mstLocationIdFilter: row.id,mstLocationNameFilter:row.name}
              , {mstLocationId: row.id,mstLocationName:row.name}
              ,1)
        }
      }
    }
</script>